<template>
    <div>
        <Mapa
            v-if="markers.length > 0 && centerIsValid"
            :center="center"
            :markers="markers"
            :icon="icon"
            height="380px;"
            botaoimprimir="none"
            :loadHome="true"
        />

        <div v-else-if="markers.length === 0" class="text-center my-5">
            <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
            />
            <h3 class="bold">{{ $t("No records found") }}</h3>
        </div>

        <div v-else class="text-center my-5">
            Carregando mapa...
        </div>
    </div>
</template>
<script>
import Mapa from "@modules/Mapa/Resources/assets/js/includes/Mapa";
export default {
    props: ['markers'],
    components: { Mapa },
    data() {
        return {
            loading: false,
            tipo: "familias_cadastradas",
            center: {},
            // markers: [],
            icon: window.urlbase + "img/icons/map/home-plus.svg",
        };
    },
    mounted() {
        this.center = {
            lat: Number(this.$store.state.settings.app_cidade_lat),
            lng: Number(this.$store.state.settings.app_cidade_lng),
        };
        // this.getTipo(
        //     "familias_cadastradas",
        //     window.urlbase + "img/icons/map/home-plus.svg"
        // );
    },
    computed: {
        centerIsValid() {
            const lat = Number(this.center && this.center.lat);
            const lng = Number(this.center && this.center.lng);

            return Number.isFinite(lat) && Number.isFinite(lng);
        },
    },
    methods: {
        // teste(imagem) {
        //     //console.log(imagem);
        // },
        // getTipo(tipo, icon) {
        //     this.icon = icon;
        //     this.setCordenadas(tipo);
        // },
        // setCordenadas(tipo) {
        //     if (tipo == "familias_cadastradas") {
        //         axios.get("api/analytics/mapa/familias").then((response) => {
        //             this.markers = response.data;
        //         });
        //     }
        // },
    },
};
</script>
